module.exports = __webpack_public_path__ + "media/home/law-360-3883e92b.png";